import { render } from "./ResponseMessage.vue?vue&type=template&id=5a6b7fc4&scoped=true"
import script from "./ResponseMessage.vue?vue&type=script&lang=js"
export * from "./ResponseMessage.vue?vue&type=script&lang=js"

import "./ResponseMessage.vue?vue&type=style&index=0&id=5a6b7fc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6b7fc4"]])

export default __exports__